module.exports = __webpack_public_path__ + "static/media/heldane-text-web-medium.3ed584ca.eot";